import { useState } from "react";
import MyDialogContent from "@/components/MyDialogContent";
import RHFWrapper from "@/components/RHFWrapper";
import RhfInput from "@/components/rhfFields/RhfInput";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";
import { ResetSchema } from "@/pages/ResetPassword";
import AxiosInstance from "@/utils/AxiosInstance";
import { getPromise, getPromiseToast } from "@/utils/helpers";

type Props = {
  patientId?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function UpdatePatientPasswordDialog({ patientId, open, onOpenChange }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handlePasswordChange = async (formData: { password: string; confirmPassword: string }) => {
    if (!patientId) return;

    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);

    try {
      setIsSubmitting(true);
      await AxiosInstance().post("/auth/admin/reset-password", {
        entityId: patientId,
        password: formData.password,
        role: "patient",
      });
      onOpenChange(false);
      resolveFn("Password changed successfully");
    } catch (error) {
      rejectFn(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <MyDialogContent className="md:w-md" heading="Update Password">
        <RHFWrapper
          initialValues={{}}
          isValidate
          onSubmit={handlePasswordChange}
          validateSchema={ResetSchema}
          className="space-y-4"
        >
          <RhfInput
            name="password"
            label="Password"
            type="password"
            placeholder="Password"
          />
          <RhfInput
            name="confirmPassword"
            label="Confirm Password"
            type="password"
            placeholder="Confirm Password"
          />
          <Button type="submit" disabled={isSubmitting} className="w-full">
            Update
          </Button>
        </RHFWrapper>
      </MyDialogContent>
    </Dialog>
  );
}
